import React from "react";

const SumoRobotSaranaBelajar: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">
                🤖 Lomba Sumo Robot Game sebagai Sarana Pembelajaran
            </h2>

            <p className="mb-4">
                Perkembangan teknologi digital dan kecerdasan buatan mendorong kebutuhan akan metode pembelajaran yang tidak hanya berbasis teori, tetapi juga praktik langsung. Pendekatan pembelajaran berbasis eksperimen kini semakin banyak diterapkan oleh berbagai lembaga edukasi robotik dan komunitas teknologi.
            </p>

            <p className="mb-4">
                Beberapa platform yang aktif mengembangkan pembelajaran robotika antara lain{' '}
                <a
                    href="https://indobot.co.id/"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Indobot Academy
                </a>
                ,{' '}
                <a
                    href="https://sekolahrobot.co.id/"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Sekolah Robot Indonesia
                </a>
                . Sejalan dengan tren tersebut, Lomba Sumo Robot Game hadir sebagai sarana edukatif yang menggabungkan teori dan implementasi langsung dalam dunia robotik.
            </p>

            <h3 className="text-md font-semibold mb-2">
                🏆 Pembelajaran Melalui Kompetisi Robotik
            </h3>

            <p className="mb-4">
                Tren pembelajaran robotik berbasis praktik juga tercermin dari berbagai ajang kompetisi robotik nasional. Institut Teknologi Bandung (ITB), misalnya, menjadi tuan rumah{' '}
                <a
                    href="https://itb.ac.id/news/itb-hosts-abu-indonesia-robot-contest-2025-strengthening-the-national-robotics-research-ecosystem/62624"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Kontes Robot ABU Indonesia (KRAI) 2025
                </a>
                , yang menjadi ajang seleksi menuju ABU Robocon Asia-Pacific dan mendorong inovasi di bidang robotik.
            </p>

            <p className="mb-4">
                Melalui kompetisi, peserta belajar merancang robot dengan mempertimbangkan keseimbangan mekanik, kecepatan respons sensor, serta algoritma pemrograman yang efisien dan stabil.
            </p>

            <h3 className="text-md font-semibold mb-2">
                ⚙️ Robotik, AI, dan Implementasi Nyata
            </h3>

            <p className="mb-4">
                Logika pemrograman yang diterapkan dalam robot mencerminkan konsep dasar kecerdasan buatan, di mana sistem mampu merespons kondisi tertentu secara otomatis tanpa intervensi manusia. Pendekatan ini memberikan gambaran nyata mengenai cara kerja sistem cerdas di dunia industri dan teknologi modern.
            </p>

            <h3 className="text-md font-semibold mb-2">
                🚀 Dukungan Talenta Digital Sejak Dini
            </h3>

            <p className="mb-4">
                Minat terhadap ekskul robot di sekolah terus meningkat seiring dengan dorongan penguatan talenta digital sejak dini yang kerap disampaikan dalam berbagai diskusi publik. Dukungan pembelajaran robotik dan STEM juga diperkuat oleh platform edukasi seperti AEDU (Accelist Edukasi).
            </p>

            <p className="mb-4">
                Informasi lengkap mengenai program AEDU dapat diakses melalui{' '}
                <a
                    href="https://edukasi.accelist.com/"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    website AEDU
                </a>.
            </p>

            <p className="text-gray-700">
                Melalui kompetisi yang diselenggarakan oleh <strong>IIT</strong>, Lomba Sumo Robot Game menjadi wadah pembinaan yang terstruktur dan berkelanjutan. Kompetisi ini mendorong peserta untuk memahami fondasi rekayasa, pemrograman, dan kecerdasan buatan sebagai bekal menghadapi perkembangan teknologi di masa depan.
            </p>

            <p className="mt-4 font-semibold">
                👉 Cek informasi Lomba{' '}
                <a
                    href="/iit-program?program=SumoRobot"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                >
                    Sumo Robot Game
                </a>{' '}
                lebih lanjut
            </p>
        </div>
    );
};

export default SumoRobotSaranaBelajar;
